import { lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import LandingPage from "./Landing.tsx";
import AppTheme from "./theme/AppTheme.tsx";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";

const LazyApp = lazy(() => import("./App"));

const LoadedApp = () =>
  (location.hostname === "localhost" &&
    !location.pathname.includes("test_landing")) ||
  location.hostname.includes("app") ? (
    <AppTheme>
      <QueryClientProvider client={new QueryClient({})}>
        <LazyApp />
      </QueryClientProvider>
    </AppTheme>
  ) : (
    <LandingPage />
  );

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LoadedApp />
  </StrictMode>
);
